import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import FormInput from "../../components/Forms/FormInputs/FormInput";
import FormPassInput from "../../components/Forms/FormInputs/FormPassInput";
import "../../components/Forms/FormInputs/formInput.scss";
import { Formik } from "formik";
import axios from "axios";

// Context
import { CurrentUserContext } from "context/UserContext";

//assets imports
import warning from "assets/icons/warning.png";
import PageButton from "components/PageButton/PageButton";

const validation = (values) => {
  const errors = {};
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!values.email) {
    errors.email = "Ingresa un email";
  } else if (!regex.test(values.email)) {
    errors.email = "El email no tiene un formato válido";
  }
  if (!values.password) {
    errors.password = "Ingresa tu contraseña";
  } else if (values.password.length < 6) {
    errors.password = "La contraseña debe tener más de 6 caracteres";
  }

  return errors;
};

const LoginForm = (props) => {
  const [, setUserContextData] = useContext(CurrentUserContext);
  const history = useHistory();
  const [errorState, setErrorState] = useState(false);
  let location = useLocation();
  let from = location.state?.from;

  //Api for the User
  const login = async (email, password) => {
    try {
      const resultado = await axios.post(
        `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/authenticate`,
        {
          email: email,
          password: password,
        }
      );

      setUserContextData({
        id: resultado.data.user.id,
        name: resultado.data.user.name,
        surname: resultado.data.user.surname,
        email: resultado.data.user.email,
        city: resultado.data.user.city,
        jwt: resultado.data.jwt,
        isLoggedIn: true,
        admin : resultado.data.user.admin
      });
      if (from) {
        history.push(from);
      } else {
        history.push("/home");
      }
    } catch (error) {
      setErrorState(true);
      console.log(error.message);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={async (values, actions) => {
          await login(values.email, values.password);
          actions.setSubmitting(false);
        }}
        validate={validation}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {/**This props are injected by Formik*/}
        {(props) => (
          <LoginFormTemplate {...props} from={from} errorState={errorState} />
        )}
      </Formik>
    </>
  );
};

const LoginFormTemplate = ({
  handleSubmit,
  isSubmitting,
  from,
  errorState,
}) => {
  return (
    <div className="login__container">
      {from && (
        <div className="errorLoginReserve">
          <img src={warning} alt="warning" />
          <p> Para hacer una reserva necesitas estar logueado</p>
        </div>
      )}
      {errorState && (
        <div className="errorLoginReserve">
          <img src={warning} alt="warning" />
          <p>
            {" "}
            Lamentablemente no ha podido iniciar sesión. Por favor, intente más
            tarde
          </p>
        </div>
      )}
      <h1>Iniciar Sesión</h1>

      <form className="login__container__form" onSubmit={handleSubmit}>
        <div className="login__container__form__input">
          <FormInput
            name="email"
            type="text"
            inputMode="email"
            label="Correo"
          />
          <FormPassInput name="password" type="password" label="Contraseña" />
        </div>

        <PageButton
          filled
          disabled={isSubmitting}
          className="standardWidth"
          type="submit"
          label="Ingresar"
        />
        <p>
          ¿Aún no tenés cuenta? <Link to="/signup"> Regístrate </Link>
        </p>
      </form>
    </div>
  );
};

export default LoginForm;
